// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overlay[data-v-8d10d7e6]{width:100%;height:100%;position:absolute;top:0;left:0;background-color:var(--overlay-bg);z-index:1}h2.setting-title[data-v-8d10d7e6]{align-items:center;display:flex}h2.setting-title>i[data-v-8d10d7e6]{padding-left:5px}", ""]);
// Exports
module.exports = exports;
